module.exports = __webpack_public_path__ + "img/swin.6893206b.svg";